import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function LegalLayout({ title, lastUpdated, children }) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-padding animate-fade-in" style={{
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'var(--bg-primary)',
      paddingTop: '3rem',
      paddingBottom: '5rem',
      overflowY: 'auto'
    }}>
      <div style={{
        maxWidth: '65ch',
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem'
      }}>
        <button 
          onClick={() => navigate('/')}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--text-secondary)',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '600',
            alignSelf: 'flex-start',
            padding: 0,
            outline: 'none',
            transition: 'color var(--transition-fast)'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = 'var(--text-primary)'}
          onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}
        >
          <ArrowLeft size={16} />
          Return
        </button>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <h1 style={{ 
            color: 'var(--text-primary)', 
            fontSize: 'clamp(2rem, 5vw, 2.75rem)', 
            fontWeight: '800',
            letterSpacing: '-0.02em',
            margin: 0
          }}>
            {title}
          </h1>
          <p style={{ 
            color: 'var(--text-muted)', 
            fontSize: '0.9rem', 
            fontWeight: '500',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Last Updated: {lastUpdated}
          </p>
        </div>

        <div className="legal-content" style={{
          color: 'rgba(255, 255, 255, 0.75)', /* soft muted grey */
          fontSize: '1.05rem',
          lineHeight: '1.75',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          fontWeight: '400'
        }}>
          <style>{`
            .legal-content h2 { color: var(--text-primary); font-size: 1.5rem; margin-top: 1.5rem; margin-bottom: 0.5rem; letter-spacing: -0.01em; }
            .legal-content h3 { color: var(--text-primary); font-size: 1.25rem; margin-top: 1rem; margin-bottom: 0.5rem; }
            .legal-content p { margin: 0; }
            .legal-content ul { margin: 0; padding-left: 1.5rem; }
            .legal-content li { margin-bottom: 0.5rem; }
            .legal-content strong { color: var(--text-primary); font-weight: 700; }
            .legal-content a { color: var(--text-primary); text-decoration: underline; text-decoration-color: rgba(255, 255, 255, 0.2); text-underline-offset: 4px; transition: all 0.2s ease; }
            .legal-content a:hover { color: var(--accent-primary); text-decoration-color: var(--accent-primary); }
          `}</style>
          {children}
        </div>

        {/* Global Copyright Footer for Legal Pages */}
        <div style={{
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.05)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5rem',
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '0.85rem'
        }}>
          <span>&copy; {new Date().getFullYear()} SacredMothr. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
}
